import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '/support', component: () => import('@/views/public/support'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  }
]

export const asyncRouterMap = [
  //TODO
  {
    path: '/todo',
    component: Layout,
    // redirect: '/todo/waitingParcel',
    name: 'todo',
    meta: { title: 'ToDo' },
    children: [
      {
        path: 'waitingCollect',
        name: 'waitingCollect',
        component: () => import('@/views/todo/waitingCollect'),
        meta: { title: 'waitingCollect' }
      }, {
        path: 'waitingPack',
        name: 'waitingPack',
        component: () => import('@/views/todo/waitingPack'),
        meta: { title: 'waitingPack' }
      }, {
        path: 'waitingShipping',
        name: 'waitingShipping',
        component: () => import('@/views/todo/waitingShipping'),
        meta: { title: 'waitingPack' }
      },
      {
        path: 'waitingForPallet',
        name: 'waitingForPallet',
        component: () => import('@/views/todo/waitingForPallet'),
        meta: { title: '等待装Pallet' }
      },
      {
        path: 'readyPackPallet',
        name: 'readyPackPallet',
        component: () => import('@/views/todo/pallet/readyPackPallet'),
        meta: { title: '等待装Pallet' },
        hidden: true
      },
      {
        path: 'checkItemImage',
        name: 'checkItemImage',
        component: () => import('@/views/todo/valid/checkItemImage'),
        meta: { title: '审核收件人图片', icon: 'validImage' }
      },
      {
        path: 'unknownItem',
        name: 'unknownItem',
        component: () => import('@/views/todo/item/unknownItem'),
        meta: { title: '未知包裹' }
      },
      {
        path: 'autoScanItem',
        name: 'autoScanItem',
        component: () => import('@/views/todo/item/autoScanItem'),
        meta: { title: '自动扫描包裹' }
      },
      {
        path: 'autoScanBox',
        name: 'autoScanBox',
        component: () => import('@/views/todo/box/autoScanBox'),
        meta: { title: '自动扫描箱子' }
      }
      , {
        path: 'lostList',
        name: 'lostList',
        component: () => import('@/views/todo/item/lostList'),
        meta: { title: '丢失包裹' }
      }, {
        path: 'specialItemList',
        name: 'specialItemList',
        component: () => import('@/views/todo/item/specialItemList'),
        meta: { title: '特殊物品', icon: "special" }
      }, {
        path: 'transferItem',
        name: 'transferItem',
        component: () => import('@/views/todo/transfer/index'),
        meta: { title: '转运包裹', icon: "transfer" }
      },
      {
        path: 'timeoutItemList',
        name: 'timeoutItemList',
        component: () => import('@/views/todo/item/itemTimeoutList'),
        meta: { title: '超时包裹', icon: 'timeout' }
      },
      {
        path: 'customerReceiver',
        name: 'customerReceiver',
        component: () => import('@/views/todo/valid/customerReceiver'),
        meta: { title: '验证客户地址', icon: 'valid' }
      },
      {
        path: 'superCheckItemImage',
        name: 'superCheckItemImage',
        component: () => import('@/views/todo/valid/superCheckItemImage'),
        meta: { title: '总仓库审核图片', icon: 'validImage' }
      }, {
        path: 'todoOrder',
        name: 'todoOrder',
        component: () => import('@/views/todo/order/todoOrder'),
        meta: { title: '异常订单', icon: "pending" }
      }
      , {
        path: 'itemFileCheck',
        name: 'itemFileCheck',
        component: () => import('@/views/todo/valid/checkItemFiles'),
        meta: { title: '包裹文件验证' }
      }
      , {
        path: 'urgeItemList',
        name: 'urgeItemList',
        component: () => import('@/views/todo/item/urgeItemList'),
        meta: { title: '催促录入列表', icon: "urge" }
      },
      {
        path: 'itemAbnormal',
        name: 'itemAbnormal',
        component: () => import('@/views/todo/item/itemAbnormal'),
        meta: { title: '决策异常包裹' }
      },
      {
        path: 'todoItem',
        name: 'todoItem',
        component: () => import('@/views/todo/item/todoItem'),
        meta: { title: '待处理包裹', icon: "handle" }
      },
      {
        path: 'importOrder',
        name: 'importOrder',
        component: () => import('@/views/list/order/importOrder'),
        meta: { title: '导入订单', icon: "import" }
      },
      {
        path: 'getUserListNoOrder',
        name: 'getUserListNoOrder',
        component: () => import('@/views/todo/user/getUserListNoOrder'),
        meta: { title: '半年无下单用户列表', icon: "list" }
      },
      {
        path: 'todoBusiness',
        name: 'todoBusiness',
        component: () => import('@/views/todo/business/todoBusiness'),
        meta: { title: 'todo-商业用户', icon: "business" }
      },
      {
        path: 'todoList',
        name: 'todoList',
        component: () => import('@/views/todo/todoList'),
        meta: { title: 'todo-list', icon: "pending" }
      },
      {
        path: 'chat-customer',
        name: 'chat-customer',
        component: () => import('@/views/todo/chat-customer'),
        meta: { title: '客户消息', icon: "chat" }
      }
    ]
  },
  //列表
  {
    path: '/list',
    component: Layout,
    name: 'list',
    meta: { title: 'List' },
    children: [
      {
        path: 'item',
        name: 'item',
        component: () => import('@/views/list/item/itemList'),
        meta: { title: 'item列表' }
      }, {
        path: 'order',
        name: 'order',
        component: () => import('@/views/list/orderList'),
        meta: { title: 'order列表' }
      }
      ,
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/list/orderDetail'),
        meta: { title: '订单详情' },
        hidden: true
      }, {
        path: 'box',
        name: 'box',
        component: () => import('@/views/list/box'),
        meta: { title: 'box列表' }
      }, {
        path: 'pallet',
        name: 'pallet',
        component: () => import('@/views/list/pallet'),
        meta: { title: 'pallet列表' }
      }, {
        path: 'shipping',
        name: 'shipping',
        component: () => import('@/views/list/shipping'),
        meta: { title: 'shipping列表' }
      }, {
        path: 'userList',
        name: 'userList',
        component: () => import('@/views/list/user/userList'),
        meta: { title: '用户列表' }
      },
      {
        path: 'logList',
        name: 'logList',
        component: () => import('@/views/list/log/index'),
        meta: { title: '日志列表' },
      },
      {
        path: 'userDetail',
        name: 'userDetail',
        component: () => import('@/views/list/components/UserDetail'),
        meta: { title: '用戶详情' },
        hidden: true
      },
      {
        path: 'itemReport',
        name: 'itemReport',
        component: () => import('@/views/list/item/report'),
        meta: { title: '包裹统计' },
        hidden: true
      }, {
        path: 'unknownRecordList',
        name: 'unknownRecordList',
        component: () => import('@/views/list/unknownRecordList'),
        meta: { title: '未知包裹记录' }
      }
      , {
        path: 'smsCodeList',
        name: 'smsCodeList',
        component: () => import('@/views/list/smsCodeList'),
        meta: { title: '短信列表' }
      },
      {
        path: 'logDetail',
        name: 'logDetail',
        component: () => import('@/views/list/components/OrderLogDetail'),
        meta: { title: '日志列表' },
        hidden: true
      },
      {
        path: 'itemLogDetail',
        name: 'itemLogDetail',
        component: () => import('@/views/list/components/ItemLogDetail'),
        meta: { title: '日志列表' },
        hidden: true
      }, {
        path: 'TrackingDetail',
        name: 'TrackingDetail',
        component: () => import('@/views/list/components/TrackingDetail'),
        meta: { title: '运单追踪' },
        hidden: true
      }, {
        path: 'refundList',
        name: 'refundList',
        component: () => import('@/views/list/order/refundList'),
        meta: { title: '退款列表', icon: 'refund' }
      }, {
        path: 'downloadFiles',
        name: 'downloadFiles',
        component: () => import('@/views/list/downloadFiles'),
        meta: { title: '下载资源', icon: 'refund' }
      }


    ]
  },
  //营销
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: { title: '营销', icon: 'sms' },
    children: [
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: { title: '优惠券列表', icon: 'sms-coupon' }
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: { title: '添加优惠券' },
        hidden: true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: { title: '修改优惠券' },
        hidden: true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: { title: '优惠券领取详情' },
        hidden: true
      },
      {
        path: 'grantCoupon',
        name: 'grantCoupon',
        component: () => import('@/views/sms/coupon/grantCoupon'),
        meta: { title: '发放优惠券' }
      },
      {
        path: 'allCouponHistory',
        name: 'allCouponHistory',
        component: () => import('@/views/sms/coupon/allCouponHistory'),
        meta: { title: '优惠券历史记录' }
      },
      {
        path: 'invitationUser',
        name: 'invitationUser',
        component: () => import('@/views/sms/point/invitationUserList'),
        meta: { title: '用户邀请记录', icon: 'invitation' }
      },
      {
        path: 'rewardConfig',
        name: 'rewardConfig',
        component: () => import('@/views/sms/point/rewardConfig'),
        meta: { title: '点数奖励机制', icon: 'reward' }
      },
      {
        path: 'promotion',
        name: 'promotion',
        component: () => import('@/views/sms/promotion/index'),
        meta: { title: '推广列表', icon: 'promotion' }
      },
      {
        path: 'rewardPointApply',
        name: 'rewardPointApply',
        component: () => import('@/views/sms/point/rewardPointApply'),
        meta: { title: '发放点数申请', icon: 'reward' }
      },
      {
        path: 'lottery',
        name: 'lottery',
        component: () => import('@/views/sms/lottery/lotteryList'),
        meta: { title: '抽奖', icon: 'lottery' }
      }, {
        path: 'msgBoardList',
        name: 'msgBoardList',
        component: () => import('@/views/sms/lottery/msgBoardList'),
        meta: { title: '用户留言板', icon: 'msgboard' }
      },
      {
        path: 'startLottery',
        name: 'startLottery',
        component: () => import('@/views/sms/lottery/startLottery'),
        meta: { title: '开始抽奖' },
        hidden: true
      }
    ]
  },
  //目的地
  {
    path: '/dest',
    component: Layout,
    // redirect: '/sms/coupon',
    name: 'dest',
    meta: { title: '目的地', icon: 'dest' },
    children: [
      {
        path: 'receiveShipping',
        name: 'receiveShipping',
        component: () => import('@/views/dest/index'),
        meta: { title: '接收Shipping', icon: "receive" }
      },
      {
        path: 'dispatchOrder',
        name: 'dispatchOrder',
        component: () => import('@/views/dest/dispatchOrder'),
        meta: { title: '目的地发货', icon: "dispatch" }
      },
      {
        path: 'pickup',
        name: 'pickup',
        component: () => import('@/views/dest/pickup'),
        meta: { title: '客户提货' },
        hidden: true
      },
      {
        path: 'dest_picked',
        name: 'dest_picked',
        component: () => import('@/views/dest/dest_picked'),
        meta: { title: '总仓理货', icon: 'send' }
      }, {
        path: 'dispatchHistoryList',
        name: 'dispatchHistoryList',
        component: () => import('@/views/dest/dispatchHistoryList'),
        meta: { title: '目的地发货历史' },
      },
      {
        path: 'auPostList',
        name: 'auPostList',
        component: () => import('@/views/dest/auPostList'),
        meta: { title: 'Au Post' }
      },
      {
        path: 'timeoutOrderList',
        name: 'timeoutOrderList',
        component: () => import('@/views/todo/order/orderTimeoutList'),
        meta: { title: '订单仓储超时' }
      }, {
        path: 'shippingList',
        name: 'shippingList',
        component: () => import('@/views/dest/dest-shipping'),
        meta: { title: 'Shipping查询' }
      }, {
        path: 'destReceiveLog',
        name: 'destReceiveLog',
        component: () => import('@/views/dest/destReceiveLog'),
        meta: { title: 'destReceiveLog' }
      }, {
        path: 'estimatedDeliveryFee',
        name: 'estimatedDeliveryFee',
        component: () => import('@/views/dest/estimatedDeliveryFee'),
        meta: { title: '澳洲邮费预估' }
      }
      ,
      {
        path: 'mismatchPalletVolumeList',
        name: 'mismatchPalletVolumeList',
        component: () => import('@/views/dest/mismatchPalletVolumeList'),
        meta: { title: 'Pallet尺寸有误列表' }
      },
      {
        path: 'destMap',
        name: 'destMap',
        component: () => import('@/views/dest/destOverviewMap'),
        meta: { title: '总览地图', icon: 'delivery0' }
      },
      {
        path: 'validAddress',
        name: 'validAddress',
        component: () => import('@/views/dest/validAddress'),
        meta: { title: '验证地址', icon: 'send' }
      },
      {
        path: 'all_branch_orders',
        name: 'all_branch_orders',
        component: () => import('@/views/dest/all_branch_orders'),
        meta: { title: '取货点订单总览', icon: 'list' }
      }
    ]
  },
  //取货点
  {
    path: '/pickup-branch',
    component: Layout,
    name: 'pickup-branch',
    meta: { title: '取货点', icon: 'pickup' },
    children: [,
      {
        path: 'pickup_branch',
        name: 'pickup_branch',
        component: () => import('@/views/dest/branch/pickup_branch'),
        meta: { title: '取货点客户提货' }
      },
      {
        path: 'pickup_branch_list',
        name: 'pickup_branch_list',
        component: () => import('@/views/dest/branch/pickup_branch_list'),
        meta: { title: '客户预约列表' }
      },
      {
        path: 'waiting_pick_list',
        name: 'waiting_pick_list',
        component: () => import('@/views/dest/branch/branch_waiting_pick_list'),
        meta: { title: '待取货列表' }
      },
      {
        path: 'pickup_branch_done_list',
        name: 'pickup_branch_done_list',
        component: () => import('@/views/dest/branch/pickup_branch_done_list'),
        meta: { title: '已完成取货列表' }
      }]
  },
  //配送模块
  {
    path: '/delivery',
    component: Layout,
    name: 'delivery',
    meta: { title: '配送服务', icon: 'delivery0' },
    children: [
      {
        path: 'deliveryMap',
        name: 'deliveryMap',
        component: () => import('@/views/delivery/deliveryMap'),
        meta: { title: '任务选取地图', icon: 'map' }
      },
      {
        path: 'delivery_waiting_pick',
        name: 'delivery_waiting_pick',
        component: () => import('@/views/delivery/delivery_waiting_pick'),
        meta: { title: '待取货列表', icon: 'list' }
      },
      {
        path: 'delivery_waiting_shipped',
        name: 'delivery_waiting_shipped',
        component: () => import('@/views/delivery/delivery_waiting_shipped'),
        meta: { title: '待配送列表', icon: 'list' }
      }]
  },
  //团购模块
  {
    path: '/shop',
    component: Layout,
    name: 'shop',
    meta: { title: '团购模块', icon: 'shop' },
    children: [
      {
        path: 'shop-order',
        name: 'shop-order',
        component: () => import('@/views/shop/order/index'),
        meta: { title: '团购订单', icon: 'list' }
      },
      {
        path: 'dispatch-shop-order',
        name: 'dispatch-shop-order',
        component: () => import('@/views/shop/order/dispatch/dispatchShopOrder'),
        meta: { title: '团购发货', icon: "dispatch" }
      },
      {
        path: 'dispatch-shop-order-detail',
        name: 'dispatch-shop-order-detail',
        component: () => import('@/views/shop/order/dispatch/dispatchShopOrderDetail'),
        meta: { title: '团购发货详情' }, hidden: true
      },
      {
        path: 'shop-order-detail',
        name: 'shop-order-detail',
        component: () => import('@/views/shop/order/orderDetail'),
        meta: { title: '团购订单详情' }, hidden: true
      },
      {
        path: 'shop-product',
        name: 'shop-product',
        component: () => import('@/views/shop/product/index'),
        meta: { title: '商品列表', icon: 'shop-product' }
      }, {
        path: 'shop-product-detail',
        name: 'shop-product-detail',
        component: () => import('@/views/shop/product/productDetail'),
        meta: { title: '商品详情' }, hidden: true
      },
      {
        path: 'shop-category',
        name: 'shop-category',
        component: () => import('@/views/shop/category/index'),
        meta: { title: '类别列表', icon: 'category' }
      }
    ]
  },
  //对账
  {
    path: '/fms',
    component: Layout,
    name: 'fms',
    meta: { title: '财务系统', icon: 'finance' },
    children: [{
      path: 'seaCheck',
      name: 'seaCheck',
      component: () => import('@/views/fms/seaCheck'),
      meta: { title: '海运对账' }
    }, {
      path: 'airCheck',
      name: 'airCheck',
      component: () => import('@/views/fms/airCheck'),
      meta: { title: '空运对账' }
    }
      , {
      path: 'exportMyOb',
      name: 'exportMyOb',
      component: () => import('@/views/fms/exportMyOb'),
      meta: { title: '导出MyOb' }
    }, {
      path: 'ausTrackingFeeList',
      name: 'ausTrackingFeeList',
      component: () => import('@/views/fms/ausTrackingFeeList'),
      meta: { title: '订单澳洲邮费记录' }
    }
      , {
      path: 'waitingReceivedRefundList',
      name: 'waitingReceivedRefundList',
      component: () => import('@/views/fms/waitingReceivedRefundList'),
      meta: { title: '赔偿确认' }
    },
    {
      path: 'pointLogList',
      name: 'pointLogList',
      component: () => import('@/views/fms/pointLogList'),
      meta: { title: '点数日志列表' },
    },
    {
      path: 'point-stripe',
      name: 'point-stripe',
      component: () => import('@/views/fms/point-stripe'),
      meta: { title: '上传Stripe记录', icon: 'upload' },
    },
    {
      path: 'fmsOrderList',
      name: 'fmsOrderList',
      component: () => import('@/views/fms/fmsOrderList'),
      meta: { title: '财务订单列表' },
    }
    ]
  },
  //统计
  {
    path: '/report',
    component: Layout,
    name: 'report',
    meta: { title: '统计报告', icon: 'chart' },
    children: [{
      path: 'reportOrder',
      name: 'reportOrder',
      component: () => import('@/views/report/report-order'),
      meta: { title: '订单统计' }
    }, {
      path: 'reportUser',
      name: 'reportUser',
      component: () => import('@/views/report/report-user'),
      meta: { title: '用户统计' }
    }, {
      path: 'warehouseStock',
      name: 'warehouseStock',
      component: () => import('@/views/report/warehouse-stock'),
      meta: { title: '仓库库存' }
    }, {
      path: 'reportReceived',
      name: 'reportReceived',
      component: () => import('@/views/report/reportReceived'),
      meta: { title: '包裹接收统计' }
    }
      // , {
      //   path: 'wechatList',
      //   name: 'wechatList',
      //   component: () => import('@/views/list/user/wechatList'),
      //   meta: { title: '微信列表', icon: 'wechat' }
      // }
    ]
  },
  //消息
  {
    path: '/msg',
    component: Layout,
    name: 'msg',
    meta: { title: '消息管理', icon: 'msg' },
    children: [{
      path: 'pushWxMsg',
      name: 'pushWxMsg',
      component: () => import('@/views/msg/pushWxMsg'),
      meta: { title: '微信群发消息' }
    }
      // , {
      //   path: 'reportUser',
      //   name: 'reportUser',
      //   component: () => import('@/views/report/report-user'),
      //   meta: { title: '用户统计' }
      // }
    ]
  },
  //服务
  {
    path: '/cgms',
    component: Layout,
    name: 'cgms',
    meta: { title: '配置管理' },
    children: [
      {
        path: 'warehouse',
        name: 'warehouse',
        component: () => import('@/views/cgms/warehouse'),
        meta: { title: '仓库管理', icon: 'warehouse' }
      },
      {
        path: 'service',
        name: 'service',
        component: () => import('@/views/cgms/service'),
        meta: { title: '运输服务', icon: 'freight' }
      },
      {
        path: 'declaration',
        name: 'declaration',
        component: () => import('@/views/cgms/declaration'),
        meta: { title: '报关管理' }
      },
      {
        path: 'currency',
        name: 'currency',
        component: () => import('@/views/cgms/currency'),
        meta: { title: '汇率管理' }
      },
      {
        path: 'wxQrcode',
        name: 'wxQrcode',
        component: () => import('@/views/cgms/wxQrcode'),
        meta: { title: '微信二维码' }
      },
      {
        path: 'memberLev',
        name: 'memberLev',
        component: () => import('@/views/cgms/memberLev'),
        meta: { title: '会员折扣设定', icon: 'member' }
      },
      {
        path: 'deliveryFee',
        name: 'deliveryFee',
        component: () => import('@/views/cgms/cgAuZipCode'),
        meta: { title: '运费邮编设置' }
      },

      {
        path: 'capitalPrice',
        name: 'capitalPrice',
        component: () => import('@/views/cgms/cgCapitalPrice'),
        meta: { title: 'capital邮费设置' }
      },
      {
        path: 'cgPoint',
        name: 'cgPoint',
        component: () => import('@/views/cgms/cgPoint'),
        meta: { title: '点数配置', icon: 'invitation' }
      },
      {
        path: 'configCommon',
        name: 'configCommon',
        component: () => import('@/views/cgms/common/configCommon'),
        meta: { title: '公共配置', icon: 'common' }
      },
      {
        path: 'cgPickupAddress',
        name: 'cgPickupAddress',
        component: () => import('@/views/cgms/cgPickupAddress'),
        meta: { title: '自提点设置', icon: 'pickup-add' }
      },
      {
        path: 'cgDeliveryStaff',
        name: 'cgDeliveryStaff',
        component: () => import('@/views/cgms/cgDeliveryStaff'),
        meta: { title: '配送人员管理', icon: 'deliveryStaff' }
      }
    ]
  },
  //页面设置
  {
    path: '/pageSetting',
    component: Layout,
    name: 'pageSetting',
    meta: { title: '页面设置', icon: 'setting' },
    children: [
      {
        path: 'askQuestion',
        name: 'askQuestion',
        component: () => import('@/views/cgms/askQuestion'),
        meta: { title: '服务问答设置' }
      },
      {
        path: 'homeInformConfig',
        name: 'homeInformConfig',
        component: () => import('@/views/cgms/home/index'),
        meta: { title: '首页通知配置' }
      },
      {
        path: 'addHomeInformConfig',
        name: 'addHomeInformConfig',
        component: () => import('@/views/cgms/home/add'),
        meta: { title: '添加通知' },
        hidden: true
      },
      {
        path: 'updateHomeInformConfig',
        name: 'updateHomeInformConfig',
        component: () => import('@/views/cgms/home/update'),
        meta: { title: '编辑通知' },
        hidden: true
      },
      {
        path: 'cgProductCategory',
        name: 'cgProductCategory',
        component: () => import('@/views/cgms/product/cgProductCategory'),
        meta: { title: '产品类别设置', icon: 'product' }
      }, {
        path: 'cgProduct',
        name: 'cgProduct',
        component: () => import('@/views/cgms/product/cgProduct'),
        meta: { title: '产品设置', icon: 'product' }
      }, {
        path: 'cgMsgTemplate',
        name: 'cgMsgTemplate',
        component: () => import('@/views/cgms/msg/cgMsgTemplate'),
        meta: { title: '短信模板设置', icon: 'product' }
      }, {
        path: 'cgProhibitedItemList',
        name: 'cgProhibitedItemList',
        component: () => import('@/views/cgms/cgProhibitedItemList'),
        meta: { title: '违禁报关物品设置', icon: 'product' }
      }, {
        path: 'cgChatPrompt',
        name: 'cgChatPrompt',
        component: () => import('@/views/cgms/cgChatPrompt'),
        meta: { title: '聊天自动回复设置', icon: 'chat' }
      }
    ]
  },
  //权限
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js